module.exports = __webpack_public_path__ + "static/calendar-a8e69956047aedd60bd085369b974b27.pdf";